export class checkout_login_controller {
    compeleteInfo: any;
    registerErrMsg: string;
    errMessage: string;
    returnUrl: any;
    ajaxLoading: boolean;
    cities: any;
    provinces: any;
    datepickerConfig = {
        allowFuture: false,
        dateFormat: 'jYYYY/jMM/jDD',
        gregorianDateFormat: 'YYYY/DD/MM',
        dropDownYears: 100
    }
    isNewUser = false
    constructor(private $geo, private $user, private $location: ng.ILocationService, private $window: ng.IWindowService, private $state: ng.ui.IStateService, private $profile, private $notify,private MyConstant) {
        "ngInject"
    }

    $onInit() {
        this.compeleteInfo = this.$state.params.compeleteInfo == "true"
        let regExp = new RegExp("https?://([a-zA-z._<>:0-9]*)/")
        this.returnUrl = this.$location.absUrl().replace(regExp, '/')
        this.$geo.all(
            data => {
                this.provinces = data.Provinces;
                this.cities = data.Cities;
            }
        )
    }

    loginViaGoogle() {
        this.ajaxLoading = true;
        this.$user.loginViaGoogle(this.returnUrl)
    }

    registerViaGoogle() {
        this.ajaxLoading = true;
        this.$user.loginViaGoogle(this.returnUrl)
    }

    doLogin(user) {
        this.$user.login(user).then(Response => {
            console.log(Response);
            if (Response.data) {
                this.$window.location.reload();
            }
            else {
                this.errMessage = "user or password is incorrect"
            }
        })
    }

    saveInfo(user) {
        this.ajaxLoading = true;
        if (user.AcCreditCard) {
            var creditCard = user.AcCreditCard.part1 + '-' + user.AcCreditCard.part2 + '-' + user.AcCreditCard.part3 + '-' + user.AcCreditCard.part4;
            user.AcCreditCard = creditCard;
        }
        var profile = new this.$profile(user);
        profile.$save(() => {
            if (this.$state.params.returnURL) {
                this.$window.location.href = decodeURIComponent(this.$state.params.returnURL)
            }
            this.ajaxLoading = false;
            this.$notify.show({ text: "تغییرات با موفقیت ذخیره شد" })
            this.$window.location.reload()
        })

    }

    register(user) {
        if (user.AcCreditCard) {
            let creditCard = user.AcCreditCard.part1 + '-' + user.AcCreditCard.part2 + '-' + user.AcCreditCard.part3 + '-' + user.AcCreditCard.part4;
            user.AcCreditCard = creditCard;
        }
        this.$user.registerAndComplete(user).then(Response => {
            if (Response.data.ResultCode == 13) {
                this.$window.location.reload();
            }
            else {
                this.registerErrMsg = Response.data.ResultString || "مشکلی در ثبت نام شما وجود دارد لطفا همه موارد رو بررسی کنید و دوباره امتحان کنید";
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/checkout-login/checkout-login.controller.ts